<!-- <div style="width: 1680px; height: 900px" id="txDocumentEditor"></div> -->

<iframe
  *ngIf="urlTxtEditor"
  #editorIframe
  (load)="onIframeLoad()"
  [src]="urlTxtEditor"
  width="100%"
  height="1000px"
  frameborder="0"
  allow="clipboard-write; clipboard-read"
>
</iframe>
